import React from 'react';
import styles from '../styles/tag.scss';
const Tag = ({ label, className }) => {
    return React.createElement("span", { className: `${styles.tag} ${className}` }, label);
};
export default Tag;
